<div class="rounded-md border border-p-border bg-[color-mix(in_srgb,var(--p-text-color)_3%,transparent)] px-2.5 py-2 flex flex-col gap-2 text-xs">

    @switch (mode()) {

        @case ('v2') {
            @for (group of groups(); track $index; let last = $last) {
                <div class="flex flex-col gap-1" [class.pb-2]="!last" [class.border-b]="!last" [class.border-p-border]="!last">
                    <div class="flex items-baseline justify-between gap-2">
                        <span class="font-medium text-p-text">
                            @if (group.isImplicitFallback) {
                                {{ 'bookingV2.dynamicPriceBreakdown.fallback' | translate }}
                            } @else {
                                {{ group.name || ('bookingV2.dynamicPriceBreakdown.unnamedGroup' | translate) }}
                            }
                        </span>
                        <span class="tabular-nums font-medium text-p-text flex-shrink-0">{{ fmt(group.groupPrice) }} €</span>
                    </div>

                    <div class="text-p-text-muted">
                        {{ 'bookingV2.dynamicPriceBreakdown.basePrice' | translate }} {{ fmt(group.basePrice) }} €@for (c of group.calculations; track $index) {<span> · ×&nbsp;{{ c.givenValue }} {{ c.conditionEntity }}</span>}
                    </div>

                    @if (group.evaluations?.length) {
                        <div class="flex flex-wrap gap-1">
                            @for (e of group.evaluations; track $index) {
                                <span class="inline-flex items-center gap-1 rounded px-1.5 py-0.5 border border-p-border text-p-text">
                                    <span class="material-icons text-[13px] leading-none flex-shrink-0"
                                        [class.text-green-600]="e.isTrue" [class.text-red-500]="!e.isTrue"
                                        aria-hidden="true">{{ e.isTrue ? 'check' : 'close' }}</span>
                                    <span>{{ e.conditionEntity }} {{ e.conditionOperatorText }} {{ e.requiredValue }}</span>
                                    <span class="opacity-60 tabular-nums">{{ e.givenValue }}</span>
                                </span>
                            }
                        </div>
                    }
                </div>
            }
        }

        @case ('evaluations') {
            @if (ruleName(); as rule) {
                <span class="font-medium text-p-text">{{ rule }}</span>
            }
            <div class="flex flex-wrap gap-1">
                @for (e of evaluations(); track $index) {
                    <span class="inline-flex items-center gap-1 rounded px-1.5 py-0.5 bg-p-content-bg border border-p-border text-p-text-muted">
                        <span class="material-icons text-[13px] leading-none flex-shrink-0"
                            [class.text-green-600]="e.isTrue" [class.text-red-500]="!e.isTrue"
                            aria-hidden="true">{{ e.isTrue ? 'check' : 'close' }}</span>
                        <span>{{ e.conditionEntity }} {{ e.conditionOperatorText }} {{ e.requiredValue }}</span>
                        <span class="opacity-60 tabular-nums">{{ e.givenValue }}</span>
                    </span>
                }
            </div>
        }

        @case ('calculations') {
            <div class="flex flex-col gap-0.5 text-p-text-muted">
                @for (c of calculations(); track $index) {
                    <span class="tabular-nums">
                        {{ fmt(c.priceBeforeCalculation) }} {{ c.conditionOperatorSymbol }} {{ c.givenValue }}
                        ({{ c.conditionEntity }}) = <span class="text-p-text">{{ fmt(c.priceAfterCalculation) }} €</span>
                    </span>
                }
            </div>
        }

        @default {
            <span class="text-p-text-muted">{{ 'bookingV2.dynamicPriceBreakdown.empty' | translate }}</span>
        }
    }

    @if (mode() !== 'empty' && total() !== null) {
        <div class="flex items-baseline justify-between gap-2 pt-1.5 border-t border-p-border">
            <span class="font-semibold uppercase tracking-wide text-[11px] text-p-text-muted">{{ 'bookingV2.dynamicPriceBreakdown.total' | translate }}</span>
            <span class="tabular-nums font-semibold text-p-text">{{ fmt(total()!) }} €</span>
        </div>
    }
</div>
